import React, { useEffect, useState } from 'react';
import { getOpeningHours } from '../functions/getOpeningHours';

function Otvorenie() {
    const [openingHours, setOpeningHours] = useState(null);
    const [isSummer, setIsSummer] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadHours = async () => {
            const data = await getOpeningHours();
            if (data.ok && data.data) {
                setOpeningHours(data.data);
                setIsSummer(data.season === 'summer');
            }
            setLoading(false);
        };
        loadHours();
    }, []);

    const getDayName = (date) => {
        const days = ['NE', 'PO', 'UT', 'ST', 'ŠT', 'PI', 'SO'];
        return days[date.getDay()];
    };

    const getDayLabel = (date, index) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);
        
        const diffTime = checkDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        const dayName = getDayName(date);
        if (diffDays === 0) return dayName + ' (DNES)';
        if (diffDays === 1) return dayName + ' (ZAJTRA)';
        return dayName;
    };

    const getNext7Days = () => {
        const days = [];
        const today = new Date();
        for (let i = 0; i < 7; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);
            days.push(date);
        }
        return days;
    };

    if (loading) {
        return <div style={{color: 'white', textAlign: 'center'}}>Načítavanie...</div>;
    }

    if (!openingHours) {
        return <div style={{color: 'white', textAlign: 'center'}}>Chyba pri načítaní otváracích hodín</div>;
    }

    const days = ['PO', 'UT', 'ST', 'ŠT', 'PI', 'SO', 'NE'];
    
    if (openingHours.mode === 'static') {
        // Static mode - show weekly schedule
        if (isSummer) {
            // Summer: Show Bufet and Traily
            return (
                <>
                    <div style={{ paddingBottom: '30px', color: '#84d9ad', marginTop: '10px' }} className="daily-header">Bufet</div>
                    <table className="otvorenie styled-table">
                        <tbody>
                            {days.map(day => (
                                <tr key={day}>
                                    <td>{day}</td>
                                    <td>{openingHours.staticHours?.bufet?.[day] || 'ZATVORENÉ'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div style={{ paddingBottom: '30px', color: '#84d9ad' }} className="daily-header">Traily</div>
                    <table className="otvorenie styled-table">
                        <tbody>
                            {days.map(day => (
                                <tr key={day}>
                                    <td>{day}</td>
                                    <td>{openingHours.staticHours?.traily?.[day] || 'ZATVORENÉ'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            );
        } else {
            // Winter: Show only Opening Hours
            return (
                <>
                                        <table className="otvorenie styled-table">
                        <tbody>
                            {days.map(day => (
                                <tr key={day}>
                                    <td>{day}</td>
                                    <td>{openingHours.staticHours?.openingHours?.[day] || 'ZATVORENÉ'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            );
        }
    } else {
        // Dynamic mode - show next 7 days
        const next7Days = getNext7Days();
        const dynamicDates = openingHours.dynamicDates || [];
        
        // Create a map of dates for quick lookup
        const dateMap = {};
        dynamicDates.forEach(item => {
            if (item.date) {
                dateMap[item.date] = item;
            }
        });

        if (isSummer) {
            // Summer: Show Bufet and Traily
            return (
                <>
                    <div style={{ paddingBottom: '30px', color: '#84d9ad', marginTop: '10px' }} className="daily-header">Bufet</div>
                    <table className="otvorenie styled-table">
                        <tbody>
                            {next7Days.map((date, index) => {
                                const dateStr = date.toISOString().split('T')[0];
                                const dateData = dateMap[dateStr];
                                return (
                                    <tr key={index}>
                                        <td>{getDayLabel(date, index)}</td>
                                        <td>{dateData?.bufet || 'ZATVORENÉ'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    <div style={{ paddingBottom: '30px', color: '#84d9ad' }} className="daily-header">Traily</div>
                    <table className="otvorenie styled-table">
                        <tbody>
                            {next7Days.map((date, index) => {
                                const dateStr = date.toISOString().split('T')[0];
                                const dateData = dateMap[dateStr];
                                return (
                                    <tr key={index}>
                                        <td>{getDayLabel(date, index)}</td>
                                        <td>{dateData?.traily || 'ZATVORENÉ'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </>
            );
        } else {
            // Winter: Show only Opening Hours
            return (
                <>
                    <table className="otvorenie styled-table">
                        <tbody>
                            {next7Days.map((date, index) => {
                                const dateStr = date.toISOString().split('T')[0];
                                const dateData = dateMap[dateStr];
                                return (
                                    <tr key={index}>
                                        <td>{getDayLabel(date, index)}</td>
                                        <td>{dateData?.openingHours || 'ZATVORENÉ'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </>
            );
        }
    }
}

export default Otvorenie